import { render, staticRenderFns } from "./Flavors.vue?vue&type=template&id=2f29986b&scoped=true"
import script from "./Flavors.vue?vue&type=script&lang=js"
export * from "./Flavors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f29986b",
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator});
